import { AxiosError, RawAxiosResponseHeaders } from 'axios';
import { toaster } from 'components/v2/toast';
import { getAdminIlcdEpdBundle } from 'services/api/adminApi';

export default async function downloadLcdEpdByAdmin(epdVersionId: string) {
  try {
    const response = await getAdminIlcdEpdBundle(epdVersionId);
    const fileName = getFileNameFromHeaders(response.headers);
    const blob = await response.data;
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileName ?? 'ILCD.zip';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(objectUrl);
  } catch (e) {
    if (e instanceof AxiosError) {
      const responseText = await e.response?.data.text();
      const responseData = responseText ? JSON.parse(responseText) : null;
      const detail = responseData?.detail;
      toaster({
        severity: 'error',
        summary: 'Downloading error',
        details: (e.message || 'Unexpected error') + (detail && ` (${detail})`),
      });
    }
  }
}

function getFileNameFromHeaders(headers: RawAxiosResponseHeaders): string | null {
  const contentDisposition = headers['content-disposition'];
  if (typeof contentDisposition !== 'string') {
    return null;
  }
  // Regexp based on: https://stackoverflow.com/a/23054920
  const filenameRegex = /filename[^;=\n]*=((['"])(.*?)\2|[^;\n]*)/;
  const match = contentDisposition.match(filenameRegex);
  if (!match) {
    return null;
  }
  return match[3];
}
